import React from 'react';
import LegalLayout, { H2, P, UL } from '../components/legal/LegalLayout';

// Refund Policy — wording VERBATIM from the official document.

export default function RefundPolicyPage() {
  return (
    <LegalLayout title="REFUND POLICY" lastUpdated="August 19th, 2026" testId="refund-page">
      <H2 id="1">1. OUR COMMITMENT</H2>
      <P>At HiBFF.com, we want you to feel confident in your subscription decision. We offer a 30-day money-back guarantee on initial purchases for all paid subscription tiers processed via Stripe.</P>

      <H2 id="2">2. 30-DAY REFUND ELIGIBILITY</H2>
      <P>You may request a full refund within 30 days of your initial subscription purchase date for any of our plans:</P>
      <UL items={[
        'Challenger – $9/month',
        'The Elite – $33/month',
        'Master – $290/year ($24/month, billed annually)',
      ]} />
      <P><strong>Refund Window Conditions:</strong></P>
      <UL items={[
        'Refunds apply to first-time initial purchases.',
        'Automatic recurring monthly renewal charges are eligible for a full refund if requested within 48 hours of the renewal charge date.',
        'Subscription cancellations requested after the 30-day initial window (or after 48 hours for renewals) will stop future billing but do not qualify for a retroactive refund for unused days in the active cycle.',
      ]} />

      <H2 id="3">3. HOW REFUNDS ARE PROCESSED</H2>
      <P>All approved refunds are submitted directly through the Stripe Dashboard API back to the original payment card or method used at checkout.</P>
      <UL items={[
        <><strong>Processing Time:</strong> Stripe submits refunds immediately to your card issuer. Refunds typically take 5 to 10 business days to appear on your bank statement, depending on your card issuer.</>,
        <><strong>Original Currency:</strong> Refunds are credited in the original currency of the charge.</>,
        <><strong>Stripe Fees:</strong> You will not be charged any extra refund processing fee by HiBFF.</>,
      ]} />

      <H2 id="4">4. HOW TO REQUEST A REFUND</H2>
      <P>To request a refund, please email our support team directly:</P>
      <UL items={[
        <><strong>Email:</strong> <a href="mailto:refund@hibff.com" className="underline text-blue-700">refund@hibff.com</a> / <a href="mailto:support@hibff.com" className="underline text-blue-700">support@hibff.com</a></>,
        <><strong>Subject Line:</strong> Refund Request - [Your Account Email]</>,
        <><strong>Required Details:</strong> Please provide your registered account email address, subscription plan name, and the transaction date or Stripe receipt number.</>,
      ]} />

      <H2 id="5">5. NON-REFUNDABLE ITEMS</H2>
      <UL items={[
        <><strong>In-App Credits ("Hearts"):</strong> Purchases of consumable in-app items or credits are non-refundable once deployed or used on the platform.</>,
        <><strong>Fraud &amp; Abuse:</strong> HiBFF Ltd reserves the right to deny refund requests in clear cases of fraud, platform abuse, or repeated guardrail violations.</>,
      ]} />
    </LegalLayout>
  );
}
